import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatRipple } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LogoutReason } from '@app/domain/enums';
import { AuthService } from '@app/services/auth/auth';

export interface RealityCheckDialogData {
  note: string;
}

@Component({
  selector: 'bingo-reality-check-dialog',
  imports: [MatRipple],
  templateUrl: './reality-check-dialog.component.html',
  styleUrl: './reality-check-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RealityCheckDialogComponent {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  protected readonly dialogRef = inject(MatDialogRef<RealityCheckDialogComponent>);
  protected readonly data = inject<RealityCheckDialogData>(MAT_DIALOG_DATA);

  protected close(): void {
    this.dialogRef.close();
  }

  protected goToAccount(): void {
    this.dialogRef.close();
    void this.router.navigate(['/account']);
  }

  protected logout(): void {
    this.dialogRef.close();
    this.authService.logout(LogoutReason.REALITY_CHECK);
  }
}
